
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetogoacabs() {



  const cardData =
  {
    keyword: '  Pune to Goa Cabs',
    heading: 'Vaishnavi Travels: Pune to Goa Cabs',
    headingDescription: 'Vaishnavi Travels offers affordable and reliable Pune to Goa Cabs, perfect for family vacations, weekend getaways, corporate tours, and group trips. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and enjoyable ride on the long Pune–Goa route. With professional chauffeurs, timely pickups, and flexible booking options, we make coastal travel convenient and stress-free. Whether it’s a beach holiday, religious yatra, or business trip, Vaishnavi Travels guarantees safe, comfortable, and hassle-free cab services from Pune to Goa.',

    top: 'Top Places to Visit in Goa with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is Goa’s most vibrant beach, famous for its nightlife, water sports, and beach shacks. Tourists enjoy parasailing, jet skiing, and banana boat rides during the day. In the evening, it transforms into a party hub with clubs like Tito’s and Café Mambo. Delicious seafood, live music, and bustling crowds create a festive atmosphere. It is especially popular among young travelers and groups. Baga Beach is Goa’s ultimate hotspot for fun and entertainment."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, known as the ‘Queen of Beaches,’ is Goa’s largest and most popular sandy stretch. It attracts families, backpackers, and honeymooners alike. Water sports, beach markets, and shacks offering Goan delicacies make it lively. Tourists enjoy sunbathing, swimming, and shopping for souvenirs. The festive energy here peaks during Christmas and New Year. Calangute is Goa’s bustling hub of sun, sand, and fun."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada, built in 1612 by the Portuguese, is a well-preserved sea fort overlooking the Arabian Sea. It once guarded against Dutch and Maratha invasions. The fort includes a historic lighthouse and massive ramparts. Tourists enjoy panoramic views of the coastline and Mandovi River. Its heritage significance makes it a must-visit for history lovers. Fort Aguada is Goa’s symbol of colonial strength and architecture."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is one of the most revered churches in Goa. Built in 1605, it houses the mortal remains of St. Francis Xavier. The baroque architecture and gilded altars reflect Portuguese artistry. Pilgrims and tourists alike admire its spiritual and historic aura. Festivals and feasts here attract large crowds. Bom Jesus Basilica is Goa’s sacred landmark of faith and heritage."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is famous for its bohemian vibe, flea markets, and trance parties. Backpackers and international tourists love its laid-back atmosphere. The Wednesday flea market offers jewelry, clothes, handicrafts, and souvenirs. Its rocky shores and scenic sunsets make it picturesque. The beach is also known for vibrant music festivals. Anjuna is Goa’s free-spirited hub of art, culture, and nightlife."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, on the Goa-Karnataka border, is one of India’s tallest waterfalls at 310 meters. The name means ‘Sea of Milk’ due to its milky white cascades. Tourists enjoy jeep safaris through Bhagwan Mahavir Wildlife Sanctuary to reach the falls. Trekking enthusiasts love the railway track trails with stunning views. Monsoon makes the falls roar in full glory. Dudhsagar is Goa’s breathtaking natural wonder."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, perched above the Chapora River, is a historic site offering panoramic views of Vagator Beach. Made famous by the Bollywood film *Dil Chahta Hai*, it attracts young crowds and photographers. The fort’s ruins tell stories of Maratha and Portuguese conflicts. Sunsets from here are particularly enchanting. It is a favorite hangout spot for couples and friends. Chapora Fort is Goa’s scenic blend of history and cinema."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach, in South Goa, is known for its crescent-shaped shoreline lined with palm trees. It is calmer compared to North Goa beaches, making it ideal for couples and families. Kayaking, dolphin-spotting, and yoga retreats add to the experience. The colorful beach huts create a lively yet relaxing atmosphere. Silent discos at night are a unique attraction here. Palolem is Goa’s peaceful yet happening seaside retreat."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral, one of Asia’s largest churches, is dedicated to St. Catherine. Its Portuguese-Gothic architecture and massive golden bell attract tourists and pilgrims. Built in the 16th century, it symbolizes the Portuguese victory over Muslim rulers. The church’s interiors are adorned with intricate altars and paintings. It remains an active place of worship and heritage. Se Cathedral is Goa’s majestic religious landmark."
  },
  {
    "title": "Mangueshi Temple",
    "description": "Shri Mangueshi Temple, located in Ponda, is one of Goa’s most important Hindu temples dedicated to Lord Shiva. Known for its beautiful architecture, white towers, and serene tank, it attracts devotees year-round. The temple blends simplicity with grandeur, featuring traditional Goan craftsmanship. Festivals like Mahashivratri are celebrated with devotion. Surrounded by greenery, it offers peace and spirituality. Mangueshi Temple is Goa’s sacred Hindu jewel."
  }
],


    "services": [
    {
      "name": "Pune Goa Cab Booking",
      "description": "Easily book reliable and comfortable cabs from Pune to Goa for solo travelers, families, and groups. Our service offers flexible booking options including one-way and round trips, ensuring a hassle-free journey to the popular beach destination. Vehicles are well-maintained with professional drivers who prioritize safety, punctuality, and customer satisfaction throughout your long-distance travel."
    },
    {
      "name": "AC Taxi Pune to Goa",
      "description": "Travel in cool comfort with our air-conditioned taxi service from Pune to Goa. Perfect for the long road trip, these AC cabs provide a refreshing environment with efficient cooling systems, plush interiors, and smooth rides. Ideal for families, corporate travelers, and tourists seeking a relaxing and pleasant journey to Goa’s scenic beaches and attractions."
    },
    {
      "name": "One Way Cab to Goa",
      "description": "Affordable one-way cab rentals from Pune to Goa or vice versa. Ideal for travelers with onward plans or drop-offs at different locations in Goa. Book your taxi with ease and benefit from transparent pricing, courteous drivers, and safe journeys tailored to your unique travel itinerary."
    },
    {
      "name": "Round Trip Goa Cab Pune",
      "description": "Convenient round trip cab services between Pune and Goa allowing you to explore the coastal paradise at your own pace. Enjoy flexible pick-up and drop-off timings, optional stops at key sightseeing points, and comfortable travel with trusted drivers experienced on this route, ensuring a memorable holiday experience."
    },
    {
      "name": "Budget Goa Cab Service",
      "description": "Cost-effective and reliable budget taxi services from Pune to Goa, suited for solo travelers or groups looking to save on transportation without compromising safety and comfort. Our fleet includes well-maintained vehicles offering basic amenities at competitive prices, ensuring your Goa trip remains affordable and enjoyable."
    },
    {
      "name": "SUV Goa Cab Hire",
      "description": "Premium SUV cab rentals for Pune to Goa trips, providing extra space, rugged comfort, and superior road handling for the long journey. Perfect for family trips, group travel, or those who prefer enhanced comfort and style during their coastal visit, these SUVs are equipped to handle diverse road conditions with ease."
    },
    {
      "name": "Family Goa Trip Cab",
      "description": "Tailored cab services for family trips from Pune to Goa, ensuring safety, convenience, and a comfortable ride. Vehicles are spacious and drivers courteous, helping families enjoy their beach vacation without transport worries, including assistance with luggage and flexible scheduling."
    },
    {
      "name": "Corporate Goa Travel Cab",
      "description": "Professional corporate cab services designed for business travelers heading from Pune to Goa. Reliable, punctual, and discreet transportation with options for AC, SUV, and luxury vehicles to suit business trips, team outings, or corporate retreats, ensuring productivity and comfort throughout your journey."
    },
    {
      "name": "Online Goa Cab Booking Pune",
      "description": "Easy and secure online booking platform for cabs from Pune to Goa. Choose your vehicle, schedule your trip, and get instant confirmation along with 24/7 customer support to ensure a smooth and stress-free booking experience for your coastal travel plans."
    },
    {
      "name": "Long Distance Goa Cab",
      "description": "Specialized long-distance cab services from Pune to Goa, offering comfortable and safe travel over the extended journey. With experienced drivers familiar with highway routes and rest stops, these cabs provide reliable transportation options designed for endurance and passenger well-being."
    },
    {
      "name": "Goa Cab with Driver",
      "description": "Hire a cab with a professional driver for your Pune to Goa trip, allowing you to relax and enjoy the scenic route without the stress of driving. Our drivers are courteous, knowledgeable about the route and local attractions, and committed to providing a smooth and enjoyable travel experience."
    },
    {
      "name": "Goa Holiday Taxi Pune",
      "description": "Make your Goa holiday special with our dedicated taxi services from Pune, tailored to tourists and holidaymakers. Enjoy flexible itineraries, sightseeing stops, and comfortable vehicles that cater to your holiday needs, whether it’s beach hopping, local excursions, or relaxation trips around Goa."
    },
    {
      "name": "Goa Road Trip Cab",
      "description": "Experience the freedom of a personalized road trip from Pune to Goa with our cab services, designed to offer maximum flexibility and comfort. Choose your own schedule, stops, and route while traveling in well-maintained vehicles with experienced drivers who enhance your road trip with safety and local insights."
    }
  ],
  "tableData": [
    ["Pune Goa Cab Booking", "AC Taxi Pune to Goa"],
    ["One Way Cab to Goa", "Round Trip Goa Cab Pune"],
    ["Budget Goa Cab Service", "SUV Goa Cab Hire"],
    ["Family Goa Trip Cab", "Corporate Goa Travel Cab"],
    ["Online Goa Cab Booking Pune", "Long Distance Goa Cab"],
    ["Goa Cab with Driver", "Goa Holiday Taxi Pune"],
    ["Goa Road Trip Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Cabs",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable cab services from Pune to Goa, perfect for vacations, family trips, and group travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller based on your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our vehicles are regularly serviced and thoroughly cleaned to ensure safety and hygiene throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Goa to provide a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive pricing covering fuel, tolls, parking, and driver allowance with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office in Pune and drop-off at your preferred destination in Goa."
  },
  {
    "WhyChooseheading": "Ideal for Leisure and Group Trips",
    "WhyChoosedescription": "Perfect for families, friends, and groups looking to explore the beaches and culture of Goa."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]






















  }




const faqData = [
  [
    {
      question: 'What is the road distance & travel time from Pune to Goa by cab?',
      answer: 'The road distance between Pune and Goa is approximately **440‑460 km**, and it takes about **8‑11 hours** depending on route, traffic, ghats, and how many stops you make. :contentReference[oaicite:0]{index=0}',
    },
    {
      question: 'What is the typical fare for a Pune to Goa cab with Vaishnavi Travels?',
      answer: 'Fares generally start around **₹8,500‑₹10,000** for a one‑way AC sedan. For SUVs or larger vehicles, it may be higher depending on comfort, stops, and route. (Prices may vary by provider.) :contentReference[oaicite:1]{index=1}',
    },
    {
      question: 'What types of vehicles are available for the Pune to Goa ride?',
      answer: 'We offer a range of options – from AC sedans (Swift/Dzire class), to SUVs (Innova, etc.), and even larger group vehicles like Tempo Travellers or Winger cabs for groups. :contentReference[oaicite:2]{index=2}',
    },
    {
      question: 'Are tolls, driver night charges and fuel included in the fare?',
      answer: 'Our fare estimates generally include fuel and tolls. Driver allowance, night halt (if required), parking, and meals are extra. We give a detailed breakdown when you get a quote. :contentReference[oaicite:3]{index=3}',
    },
    {
      question: 'Can I book a round trip or multi‑day stay with a Pune‑Goa cab?',
      answer: 'Yes — roundtrip and multi‑day packages are available. If you plan to stay in Goa for some days and return, we can offer a customized package with per kilometre or hourly rates. ',
    },
    {
      question: 'How far in advance should I book a Pune to Goa cab?',
      answer: 'Booking at least **24‑48 hours** in advance is recommended, especially during holidays, monsoon season, or weekends. Availability can be limited for larger or premium vehicles. ',
    },
    {
      question: 'What are some of the route options from Pune to Goa, and are they scenic?',
      answer: 'Popular routes include via Satara → Kolhapur → Belgaum → Mollem → Goa or via Amboli Ghat. These routes offer scenic views, waterfalls, ghats and good highway stretches. But parts of the drive during monsoon or ghats may be slower. :contentReference[oaicite:4]{index=4}',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Aditya Kharade",
    position: "Travel Enthusiast",
    feedback:
      "Booked a cab with Vaishnavi Travels from Pune to Goa — driver was punctual, the ride was comfortable and scenic, especially through Amboli ghat. Clear fare, no surprises. Highly satisfied!",
    rating: 5,
  },
  {
    name: "Ms. Gayatri Rao",
    position: "Family Vacationer",
    feedback:
      "We took an SUV from Pune to Goa. The stops were well planned, the vehicle was clean, and driver guidance on places to eat/view was appreciated. Fair pricing too compared to what I saw online. Will travel again with Vaishnavi!",
    rating: 5,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const puneToGoaCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Goa Cabs",
  "description": "Book AC and Non-AC taxis from Pune to Goa for one-way or round trips. Budget, SUV, family, corporate, and holiday cabs available with driver for Goa road trips and long-distance travel.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/pune-to-goa-cabs"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Goa"
    }
  ],
  "serviceType": [
    "Pune Goa Cab Booking",
    "AC Taxi Pune to Goa",
    "One Way Cab to Goa",
    "Round Trip Goa Cab Pune",
    "Budget Goa Cab Service",
    "SUV Goa Cab Hire",
    "Family Goa Trip Cab",
    "Corporate Goa Travel Cab",
    "Online Goa Cab Booking Pune",
    "Long Distance Goa Cab",
    "Goa Cab with Driver",
    "Goa Holiday Taxi Pune",
    "Goa Road Trip Cab"
  ],
  "availability": "https://schema.org/InStock"
};





  return (
    <div>

<Helmet>
  <title>Pune to Goa Cabs | Affordable & Comfortable Taxi Service</title>
  <meta
    name="description"
    content="Book AC and Non-AC taxis from Pune to Goa for one-way or round trips. Budget, SUV, family, corporate, and holiday cabs available with driver for Goa road trips and long-distance travel."
  />
  <meta
    name="keywords"
    content="Pune Goa Cab Booking, AC Taxi Pune to Goa, One Way Cab to Goa, Round Trip Goa Cab Pune, Budget Goa Cab Service, SUV Goa Cab Hire, Family Goa Trip Cab, Corporate Goa Travel Cab, Online Goa Cab Booking Pune, Long Distance Goa Cab, Goa Cab with Driver, Goa Holiday Taxi Pune, Goa Road Trip Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGoaCabSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabs;